import { FC } from "react"

interface LogEntryCardProps {
  log: any
  expandedLogId: string
  isFetchingRecord: boolean
  recordDetails: any
  onViewRecord: (recordId: string, recordType: string, logId: string) => void
}

const LogEntryCard: FC<LogEntryCardProps> = ({
  log,
  expandedLogId,
  isFetchingRecord,
  recordDetails,
  onViewRecord
}) => {
  return (
    <div
      className={`border rounded-md p-3 ${
        log.status === "success"
          ? "bg-green-50 border-green-300"
          : "bg-red-50 border-red-300"
      }`}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="font-medium text-sm">
          {log.status === "success" ? "✓ Success" : "✗ Failed"}
        </div>
        <div className="text-xs text-gray-500">
          {new Date(log.timestamp * 1000).toLocaleString()}
        </div>
      </div>

      {log.error_message && (
        <div className="text-sm text-red-600 mb-2">{log.error_message}</div>
      )}

      <details className="text-xs">
        <summary className="cursor-pointer font-medium mb-1">
          View Request Data
        </summary>
        <pre className="mt-2 bg-white p-2 rounded overflow-auto max-h-48">
          {JSON.stringify(log.request_data, null, 2)}
        </pre>
      </details>

      {log.status === "success" && log.record_id && (
        <div className="text-xs mt-2">
          <button
            type="button"
            onClick={() => onViewRecord(log.record_id, log.record_type, log.id)}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            {expandedLogId === log.id ? "▼ Hide" : "▶ View"} Created{" "}
            {log.record_type} (ID: {log.record_id})
          </button>

          {expandedLogId === log.id && (
            <div className="mt-2">
              {isFetchingRecord && (
                <div className="text-gray-500 py-2">
                  Loading {log.record_type} details...
                </div>
              )}
              {recordDetails && (
                <pre className="mt-2 bg-white p-2 rounded overflow-auto max-h-64 border border-gray-200">
                  {JSON.stringify(recordDetails, null, 2)}
                </pre>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default LogEntryCard
